import { Box, Button, Typography, Container, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FaFilePdf } from "react-icons/fa";
import EnglishPDF from "../assets/RelaySMS Training Guide English New.pdf";
import FrenchPDF from "../assets/RelaySMS Training Guide French New.pdf";

function TrainingGuide() {
	const { t } = useTranslation();

	return (
		<Container
			id="training-guide"
			sx={{ mt: { xs: 6, md: 1 }, mb: { xs: 6, md: 10 }, textAlign: "center", scrollMarginTop: "100px" }}
		>
			<Stack spacing={4} alignItems="center">
				<Typography
					variant="h6"
					sx={{
						fontSize: { xs: "1.2rem", md: "1.6rem" },
						color: "text.primary",
						fontWeight: 600,
						fontFamily: "'Unbounded', Ubuntu",
						textAlign: "center"
					}}
				>
					{t("HowRelaySMSWorks.TrainingTitle", "Download Training Guides")}
				</Typography>
				<Box
					sx={{
						display: "flex",
						gap: 2,
						flexDirection: { xs: "column", sm: "row" },
						justifyContent: "center",
						alignItems: "center"
					}}
				>
					<Button
						variant="contained"
						href={EnglishPDF}
						target="_blank"
						rel="noopener noreferrer"
						startIcon={<FaFilePdf />}
						sx={{
							bgcolor: "secondary.main",
							color: "primary.contrastText",
							textTransform: "none",
							fontWeight: 600,
							py: 1,
							px: 3,
							fontSize: "14px",
							fontFamily: "Ubuntu",
							transition: "all 0.3s ease",
							borderRadius: "8px",
							"&:hover": {
								bgcolor: "primary.main",
								color: "primary.contrastText",
								borderColor: "secondary.main",
								transform: "translateY(-2px)",
								boxShadow: "0 8px 20px rgba(0, 1, 88, 0.3)"
							}
						}}
					>
						{t("HowRelaySMSWorks.EnglishPDF", "English Guide (PDF)")}
					</Button>
					<Button
						variant="contained"
						href={FrenchPDF}
						target="_blank"
						rel="noopener noreferrer"
						startIcon={<FaFilePdf />}
						sx={{
							bgcolor: "primary.main",
							color: "primary.contrastText",
							textTransform: "none",
							fontWeight: 600,
							py: 1,
							px: 3,
							fontSize: "14px",
							fontFamily: "Ubuntu",
							transition: "all 0.3s ease",
							borderRadius: "8px",
							"&:hover": {
								bgcolor: "secondary.main",
								color: "primary.main",
								borderColor: "primary.main",
								transform: "translateY(-2px)",
								boxShadow: "0 8px 20px rgba(255, 158, 67, 0.3)"
							}
						}}
					>
						{t("HowRelaySMSWorks.FrenchPDF", "French Guide (PDF)")}
					</Button>
				</Box>
			</Stack>
		</Container>
	);
}

export default TrainingGuide;
